module.exports = __webpack_public_path__ + "img/supination.e7b2cd84.png";